import { z } from 'zod'

export const passwordFormSchema = z
  .object({
    password: z
      .string()
      .min(8, 'Ao menos 8 caracteres')
      .regex(new RegExp('[A-Z]', 'g'), 'Ao menos uma letra maiúscula')
      .regex(new RegExp('[0-9]', 'g'), 'Ao menos um número'),
    confirm_password: z.string().min(1, 'Obrigatório'),
  })
  .refine(({ password, confirm_password }) => password === confirm_password, {
    message: 'As senhas devem coincidir',
    path: ['confirm_password'],
  })

export type PasswordFormData = z.infer<typeof passwordFormSchema>
